export type Guide = {
  to: string;
  label: string;
  blurb: string;
  labelEn: string;
  blurbEn: string;
};

/** Fördjupande guider – nås via startsidan, sidfoten och varandra, inte via huvudmenyn. */
export const guides: Guide[] = [
  {
    to: "/flytta-till-spanien-med-barn",
    label: "Flytta till Spanien med barn",
    blurb:
      "Tidsplan, skolval och praktiska steg för familjer som planerar flytten till Costa del Sol.",
    labelEn: "Moving to Spain with children",
    blurbEn:
      "Timeline, choosing a school and practical steps for families planning a move to the Costa del Sol.",
  },
  {
    to: "/svensk-internationell-eller-spansk-skola",
    label: "Svensk, internationell eller spansk skola?",
    blurb:
      "Neutral jämförelse av läroplan, språk, återflytt och integration för de tre skolformerna.",
    labelEn: "Swedish, international or Spanish school?",
    blurbEn:
      "A neutral comparison of curriculum, language, moving back and integration for the three options.",
  },
  {
    to: "/svensk-skola-i-spanien",
    label: "Svensk skola i Spanien",
    blurb:
      "Så fungerar svensk läroplan utomlands, kompletterande svenska och återgången till Sverige.",
    labelEn: "Swedish school in Spain",
    blurbEn:
      "How the Swedish curriculum works abroad, supplementary Swedish tuition and returning to Sweden.",
  },
  {
    to: "/skola-i-marbella-och-estepona",
    label: "Skola i Marbella och Estepona",
    blurb: "Lokalguide till områden, pendling och skolalternativ mellan Marbella och Estepona.",
    labelEn: "Schools in Marbella and Estepona",
    blurbEn:
      "A local guide to areas, commuting and school options between Marbella and Estepona.",
  },
  {
    to: "/svensk-skola-marbella",
    label: "Svensk skola nära Marbella",
    blurb: "Avstånd, restider och varför familjer från Marbella och San Pedro väljer skolan.",
    labelEn: "Swedish school near Marbella",
    blurbEn:
      "Distances, travel times and why families from Marbella and San Pedro choose the school.",
  },
  {
    to: "/skola-estepona",
    label: "Skola i Estepona",
    blurb: "Skolans läge i Cancelada, restider inom kommunen och hur skolvalet ser ut lokalt.",
    labelEn: "School in Estepona",
    blurbEn:
      "Our location in Cancelada, travel times within the municipality and the local school options.",
  },
  {
    to: "/skola-cancelada",
    label: "Skola i Cancelada",
    blurb: "Närområdet, gång- och cykelavstånd samt vardagslogistiken runt skoldagen.",
    labelEn: "School in Cancelada",
    blurbEn: "The neighbourhood, walking and cycling distance and the logistics of the school day.",
  },
  {
    to: "/nie-och-folkbokforing-i-spanien",
    label: "NIE och folkbokföring",
    blurb: "Översikt över NIE, empadronamiento och sjukvård när familjen bosätter sig i Spanien.",
    labelEn: "NIE and registration in Spain",
    blurbEn:
      "An overview of the NIE, empadronamiento and healthcare when your family settles in Spain.",
  },
  {
    to: "/distansstudier-hogstadiet-gymnasiet-utomlands",
    label: "Distansstudier utomlands",
    blurb: "Hur högstadiet och gymnasiet fungerar hos oss via Sofia Distans och Hermods.",
    labelEn: "Distance learning abroad",
    blurbEn:
      "How secondary school and sixth form work at our school via Sofia Distans and Hermods.",
  },
  {
    to: "/svensk-forskola-i-spanien",
    label: "Svensk förskola i Spanien",
    blurb: "Så fungerar svensk förskolepedagogik utomlands – dagsrytm, språk och trygg inskolning.",
    labelEn: "Swedish preschool in Spain",
    blurbEn:
      "How Swedish preschool pedagogy works abroad – daily rhythm, languages and settling in.",
  },
  {
    to: "/bo-i-cancelada-och-estepona",
    label: "Bo i Cancelada och Estepona",
    blurb: "Områdesguide till Cancelada, Estepona och New Golden Mile för familjer med barn.",
    labelEn: "Living in Cancelada and Estepona",
    blurbEn:
      "An area guide to Cancelada, Estepona and the New Golden Mile for families with children.",
  },
  {
    to: "/valja-skola-utomlands",
    label: "Välja skola utomlands",
    blurb: "Svensk, internationell eller spansk skola? Frågorna som avgör valet för din familj.",
    labelEn: "Choosing a school abroad",
    blurbEn:
      "Swedish, international or Spanish school? The questions that decide it for your family.",
  },
  {
    to: "/vad-kostar-svensk-skola-i-spanien",
    label: "Vad kostar svensk skola i Spanien?",
    blurb:
      "Avgifter, vad som ingår, hur statsbidrag påverkar priset och frågor att ställa innan du skriver på.",
    labelEn: "What does Swedish school cost in Spain?",
    blurbEn:
      "Fees, what is included, how government grants affect the price, and questions to ask before signing.",
  },
];
